import api from './client';

export const adminGetPosts = (params = {}) =>
  api.get('/api/admin/posts', { params }).then(res => res.data);

export const adminGetPost = (id) =>
  api.get(`/api/admin/posts/${id}`).then(res => res.data);

export const adminCreatePost = (data) =>
  api.post('/api/admin/posts', data).then(res => res.data);

export const adminUpdatePost = (id, data) =>
  api.put(`/api/admin/posts/${id}`, data).then(res => res.data);

export const adminDeletePost = (id) =>
  api.delete(`/api/admin/posts/${id}`).then(res => res.data);
